import util from '@/utils/util'
import { userPermission } from '@/api/system/user'
import { isExpired } from '@/api/quality/order'

export default {
  namespaced: true,
  state: {
    isLoaded: false, //用户信息是否加载
    token: '', //用户token
    permission: [], //用户权限
    info: {} //用户信息
  },
  actions: {
    /**
     * 确认已经加载用户信息
     */
    isLoaded({ state }) {
      if (state.isLoaded) {
        return Promise.resolve()
      } else {
        return new Promise(resolve => {
          const timer = setInterval(() => {
            if (state.isLoaded) {
              resolve(clearInterval(timer))
            }
          }, 10)
        })
      }
    },

    /**
     * 设置用户信息
     */
    async set({ state }, info) {
      state.token = info.token || ''
      state.permission = info?.permission || []
      state.info = info
      util.db.set('user.info', info, false)
      state.isLoaded = true
    },

    /**
     * 保存用户过期信息
     */
    async saveUserExpiredInfo({ state }, info) {
      state.info = {
        ...(state.info || {}),
        effectiveTime: info.effectiveTime,
        currentTime: info.currentTime
      }
      util.db.set('user.info', state.info, false)
    },

    /**
     * 读取用户信息
     */
    async load({ state }) {
      state.info = util.db.get('user.info', {}, false)
      state.permission = state.info?.permission || []
      state.token = state.info.token || ''
      if (state.token) {
        try {
          const res = await userPermission()
          state.permission = res.returnData
        } catch (error) {
          console.log(error)
        }
        try {
          const res = await isExpired()
          state.info.effectiveTime = res.effectiveTime
          state.info.currentTime = res.currentDate
        } catch (error) {
          state.info.effectiveTime = ''
          state.info.currentTime = ''
        }
      }
      state.isLoaded = true
    },

    /**
     * 更新token
     */
    async updateToken({ state }, token) {
      state.token = token
      state.info.token = token
      util.db.set('user.info', state.info, false)
      state.isLoaded = true
    }
  }
}
